import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import router from './router';
import store from './store';
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import { getToken } from '@/utils/auth';
import { MessageBox } from 'element-ui';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/register', '/audit', '/agreement', '/forget']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, roles, accessRoutes, _window$_QIANKUN_PROP;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            NProgress.start();
            hasToken = getToken();

            if (!hasToken) {
              _context.next = 47;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 8;
              break;
            }

            next({
              path: '/'
            });
            NProgress.done();
            _context.next = 45;
            break;

          case 8:
            if (!(whiteList.indexOf(to.path) !== -1)) {
              _context.next = 13;
              break;
            }

            next();
            NProgress.done();
            _context.next = 45;
            break;

          case 13:
            hasRoles = store.getters.roles && store.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 18;
              break;
            }

            // 单体门店——进入门店详情
            if (to.name === 'StoreInfoList') {
              store.dispatch('user/get_organization_list').then(function (res) {
                if (res.data2.length === 1) {
                  next({
                    name: 'DetailStoreInfoList',
                    params: {
                      storeCode: res.data2[0].organizationCode
                    }
                  });
                } else next();
              });
            } else next();

            _context.next = 45;
            break;

          case 18:
            _context.prev = 18;
            _context.next = 21;
            return store.dispatch('user/getEmployeeAuth');

          case 21:
            _yield$store$dispatch = _context.sent;
            roles = _yield$store$dispatch.roles;
            console.log('roles ---->>>', roles); // 如果roles length为空 则调用查询用户状态接口跳转到相应入驻页面/审核页面
            // store.dispatch('user/queryUserState')

            if (roles.length) {
              _context.next = 28;
              break;
            }

            store.dispatch('user/queryUserState', {
              userCode: localStorage.getItem('userCode')
            }).then(function (res) {
              var _num = Number(res.data.merchantAuditStatus);

              console.log('_num', _num, res);

              if (_num === 1) {
                next({
                  path: '/register',
                  query: {
                    step: 1
                  }
                });
              } else if (_num === 2) {
                next({
                  path: '/audit',
                  query: {
                    type: 1
                  }
                });
              } else if (_num === 3 || _num === 0) {
                next({
                  path: '/'
                });
              } else if (_num === 4) {
                next({
                  path: '/audit',
                  query: {
                    type: 2
                  }
                });
              }
            }).catch(function () {
              store.dispatch('user/logout');
              next({
                path: '/login'
              });
              NProgress.done();
            });
            _context.next = 36;
            break;

          case 28:
            _context.next = 30;
            return store.dispatch('permission/generateRoutes', roles);

          case 30:
            accessRoutes = _context.sent;
            console.log('accessRoutes---->>>', accessRoutes);

            if (accessRoutes.length === 1) {
              // 有默认404
              MessageBox.confirm('请联系管理员开通权限！', '提示', {
                confirmButtonText: '确定',
                center: true,
                type: 'warning'
              }).then(function () {
                store.dispatch('user/logout').then(function () {
                  location.reload();
                });
              });
            }

            console.log('挂载路由', accessRoutes);
            router.addRoutes(accessRoutes);
            next(_objectSpread(_objectSpread({}, to), {}, {
              replace: true
            }));

          case 36:
            _context.next = 45;
            break;

          case 38:
            _context.prev = 38;
            _context.t0 = _context["catch"](18);
            console.log('ee---', _context.t0);
            _context.next = 43;
            return store.dispatch('user/logout');

          case 43:
            next("/login");
            NProgress.done();

          case 45:
            _context.next = 48;
            break;

          case 47:
            /* has no token*/
            if (whiteList.indexOf(to.path) !== -1) {
              next();
            } else {
              next("/login");
              store.dispatch('tagsView/delAllViews', null);
              (_window$_QIANKUN_PROP = window._QIANKUN_PROPS_) === null || _window$_QIANKUN_PROP === void 0 ? void 0 : _window$_QIANKUN_PROP.setGlobalState({
                emptyTags: null
              });
              NProgress.done();
            }

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[18, 38]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  NProgress.done();
});